import React from "react";
import { AssociatedPartnerProvider } from "@/contexts/PartnerContext";
import "@/styles/globals.css";
import { Toaster } from "@youvisa/components";
import { QueryClient, QueryClientProvider } from "react-query";

import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'

const queryClient = new QueryClient();

Bugsnag.start({
  apiKey: 'f34440f3a00631a93a020002c50f5940',
  plugins: [new BugsnagPluginReact()],
  appVersion: '0.1.0',
  releaseStage: process.env.NODE_ENV
})

const ErrorBoundary = Bugsnag.getPlugin('react')!.createErrorBoundary(React)


export default function App({ Component, pageProps }: AppPropsWithLayout) {
  const getLayout = Component.getLayout ?? ((page) => page);

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AssociatedPartnerProvider>
          {getLayout(<Component {...pageProps} />)}
          <Toaster />
        </AssociatedPartnerProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
